import React, { useState } from "react"

import classNames from "classnames"
import * as styles from "./ProjectsList.module.scss"
import { projectsList } from "../../../hooks"
import { useIntl } from "gatsby-plugin-intl"
import { Link } from "../../Link"
import Image from "../../UI/Image"

interface ProjectsListProps {
	showLoadMore?: boolean
}

const ProjectsList: React.FC<ProjectsListProps> = ({ showLoadMore = true }) => {
	const projects = projectsList

	const [visibleCount, setVisibleCount] = useState(6)

	const handleLoadMore = () => {
		setVisibleCount((prev) => prev + 6)
	}

	const loadMoreButton = classNames(
		[styles.button],
		[styles.border]
	)

	const intl = useIntl()

	return (
		<>
			{!showLoadMore && <h2 className={styles.projectsTitle}>	{intl.formatMessage({ id: "index.projects.title" })}</h2>}
			<ul className={styles.projectsList}>
				{projects.slice(0, visibleCount).map(({ title, link, banner }) => {

					return (
						<li
							key={link}
							tabIndex={0}
						>
							<Link className={styles.projectsLink} to={`/projects/${link}/`}>
								<div className={styles.projectsImgBlock}><Image src={banner} alt={intl.formatMessage({ id: title })} fill /></div>
								<h3>{intl.formatMessage({ id: title })}</h3>
							</Link>
						</li>
					)
				})}
			</ul>

			{showLoadMore && visibleCount < projects.length && (
				<div className={styles.loadMoreWrapper}>
					<button
						className={loadMoreButton}
						onClick={handleLoadMore}
					>
						{intl.formatMessage({ id: "index.projects.see-project" })}
					</button>
				</div>
			)}
		</>
	)
}

export default ProjectsList
